(function(q,g){"function"===typeof define&&define.amd?define([],g):"object"===typeof module&&module.exports?module.exports=g():q.Rellax=g()})("undefined"!==typeof window?window:global,function(){var q=function(g,u){function C(){if(3===a.options.breakpoints.length&&Array.isArray(a.options.breakpoints)){var f=!0,c=!0,b;a.options.breakpoints.forEach(function(a){"number"!==typeof a&&(c=!1);null!==b&&a<b&&(f=!1);b=a});if(f&&c)return}a.options.breakpoints=[576,768,1201];console.warn("Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted")}
    var a=Object.create(q.prototype),l=0,v=0,m=0,n=0,d=[],w=!0,A=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||function(a){return setTimeout(a,1E3/60)},p=null,x=!1;try{var k=Object.defineProperty({},"passive",{get:function(){x=!0}});window.addEventListener("testPassive",null,k);window.removeEventListener("testPassive",null,k)}catch(f){}var D=window.cancelAnimationFrame||window.mozCancelAnimationFrame||
        clearTimeout,E=window.transformProp||function(){var a=document.createElement("div");if(null===a.style.transform){var c=["Webkit","Moz","ms"],b;for(b in c)if(void 0!==a.style[c[b]+"Transform"])return c[b]+"Transform"}return"transform"}();a.options={speed:-2,verticalSpeed:null,horizontalSpeed:null,breakpoints:[576,768,1201],center:!1,wrapper:null,relativeToWrapper:!1,round:!0,vertical:!0,horizontal:!1,verticalScrollAxis:"y",horizontalScrollAxis:"x",callback:function(){}};u&&Object.keys(u).forEach(function(d){a.options[d]=
        u[d]});u&&u.breakpoints&&C();g||(g=".rellax");k="string"===typeof g?document.querySelectorAll(g):[g];if(0<k.length){a.elems=k;if(a.options.wrapper&&!a.options.wrapper.nodeType)if(k=document.querySelector(a.options.wrapper))a.options.wrapper=k;else{console.warn("Rellax: The wrapper you're trying to use doesn't exist.");return}var F,B=function(){for(var f=0;f<d.length;f++)a.elems[f].style.cssText=d[f].style;d=[];v=window.innerHeight;n=window.innerWidth;f=a.options.breakpoints;F=n<f[0]?"xs":n>=f[0]&&n<
    f[1]?"sm":n>=f[1]&&n<f[2]?"md":"lg";H();for(f=0;f<a.elems.length;f++){var c=void 0,b=a.elems[f],e=b.getAttribute("data-rellax-percentage"),y=b.getAttribute("data-rellax-speed"),t=b.getAttribute("data-rellax-xs-speed"),g=b.getAttribute("data-rellax-mobile-speed"),h=b.getAttribute("data-rellax-tablet-speed"),k=b.getAttribute("data-rellax-desktop-speed"),l=b.getAttribute("data-rellax-vertical-speed"),m=b.getAttribute("data-rellax-horizontal-speed"),p=b.getAttribute("data-rellax-vertical-scroll-axis"),
        q=b.getAttribute("data-rellax-horizontal-scroll-axis"),u=b.getAttribute("data-rellax-zindex")||0,x=b.getAttribute("data-rellax-min"),A=b.getAttribute("data-rellax-max"),C=b.getAttribute("data-rellax-min-x"),D=b.getAttribute("data-rellax-max-x"),E=b.getAttribute("data-rellax-min-y"),L=b.getAttribute("data-rellax-max-y"),r=!0;t||g||h||k?c={xs:t,sm:g,md:h,lg:k}:r=!1;t=a.options.wrapper?a.options.wrapper.scrollTop:window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;a.options.relativeToWrapper&&
    (t=(window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop)-a.options.wrapper.offsetTop);var z=a.options.vertical?e||a.options.center?t:0:0,I=a.options.horizontal?e||a.options.center?a.options.wrapper?a.options.wrapper.scrollLeft:window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft:0:0;t=z+b.getBoundingClientRect().top;g=b.clientHeight||b.offsetHeight||b.scrollHeight;h=I+b.getBoundingClientRect().left;k=b.clientWidth||b.offsetWidth||b.scrollWidth;
        z=e?e:(z-t+v)/(g+v);e=e?e:(I-h+n)/(k+n);a.options.center&&(z=e=.5);c=r&&null!==c[F]?Number(c[F]):y?y:a.options.speed;l=l?l:a.options.verticalSpeed;m=m?m:a.options.horizontalSpeed;p=p?p:a.options.verticalScrollAxis;q=q?q:a.options.horizontalScrollAxis;y=J(e,z,c,l,m);b=b.style.cssText;r="";if(e=/transform\s*:/i.exec(b))r=b.slice(e.index),r=(e=r.indexOf(";"))?" "+r.slice(11,e).replace(/\s/g,""):" "+r.slice(11).replace(/\s/g,"");d.push({baseX:y.x,baseY:y.y,top:t,left:h,height:g,width:k,speed:c,verticalSpeed:l,
            horizontalSpeed:m,verticalScrollAxis:p,horizontalScrollAxis:q,style:b,transform:r,zindex:u,min:x,max:A,minX:C,maxX:D,minY:E,maxY:L})}K();w&&(window.addEventListener("resize",B),w=!1,G())},H=function(){var d=l,c=m;l=a.options.wrapper?a.options.wrapper.scrollTop:(document.documentElement||document.body.parentNode||document.body).scrollTop||window.pageYOffset;m=a.options.wrapper?a.options.wrapper.scrollLeft:(document.documentElement||document.body.parentNode||document.body).scrollLeft||window.pageXOffset;
        a.options.relativeToWrapper&&(l=((document.documentElement||document.body.parentNode||document.body).scrollTop||window.pageYOffset)-a.options.wrapper.offsetTop);return d!=l&&a.options.vertical||c!=m&&a.options.horizontal?!0:!1},J=function(d,c,b,e,g){var f={};d=100*(g?g:b)*(1-d);c=100*(e?e:b)*(1-c);f.x=a.options.round?Math.round(d):Math.round(100*d)/100;f.y=a.options.round?Math.round(c):Math.round(100*c)/100;return f},h=function(){window.removeEventListener("resize",h);window.removeEventListener("orientationchange",
        h);(a.options.wrapper?a.options.wrapper:window).removeEventListener("scroll",h);(a.options.wrapper?a.options.wrapper:document).removeEventListener("touchmove",h);p=A(G)},G=function(){H()&&!1===w?(K(),p=A(G)):(p=null,window.addEventListener("resize",h),window.addEventListener("orientationchange",h),(a.options.wrapper?a.options.wrapper:window).addEventListener("scroll",h,x?{passive:!0}:!1),(a.options.wrapper?a.options.wrapper:document).addEventListener("touchmove",h,x?{passive:!0}:!1))},K=function(){for(var f,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       c=0;c<a.elems.length;c++){var b=d[c].verticalScrollAxis.toLowerCase(),e=d[c].horizontalScrollAxis.toLowerCase();f=-1!=b.indexOf("x")?l:0;b=-1!=b.indexOf("y")?l:0;var g=-1!=e.indexOf("x")?m:0;e=-1!=e.indexOf("y")?m:0;f=J((f+g-d[c].left+n)/(d[c].width+n),(b+e-d[c].top+v)/(d[c].height+v),d[c].speed,d[c].verticalSpeed,d[c].horizontalSpeed);e=f.y-d[c].baseY;b=f.x-d[c].baseX;null!==d[c].min&&(a.options.vertical&&!a.options.horizontal&&(e=e<=d[c].min?d[c].min:e),a.options.horizontal&&!a.options.vertical&&
    (b=b<=d[c].min?d[c].min:b));null!=d[c].minY&&(e=e<=d[c].minY?d[c].minY:e);null!=d[c].minX&&(b=b<=d[c].minX?d[c].minX:b);null!==d[c].max&&(a.options.vertical&&!a.options.horizontal&&(e=e>=d[c].max?d[c].max:e),a.options.horizontal&&!a.options.vertical&&(b=b>=d[c].max?d[c].max:b));null!=d[c].maxY&&(e=e>=d[c].maxY?d[c].maxY:e);null!=d[c].maxX&&(b=b>=d[c].maxX?d[c].maxX:b);a.elems[c].style[E]="translate3d("+(a.options.horizontal?b:"0")+"px,"+(a.options.vertical?e:"0")+"px,"+d[c].zindex+"px) "+d[c].transform}a.options.callback(f)};
        a.destroy=function(){for(var f=0;f<a.elems.length;f++)a.elems[f].style.cssText=d[f].style;w||(window.removeEventListener("resize",B),w=!0);D(p);p=null};B();a.refresh=B;return a}console.warn("Rellax: The elements you're trying to select don't exist.")};return q});





window.onload = function() {

    var rellax = new Rellax('.rellax', {
        speed: 10,
    });

    let featuredCollection = new Flickity( '.featured-collection-slider', {
        wrapAround: true,
        autoHeight: true

    });

    let ingredientSlider = new Flickity( '.ingredient__slider', {
        adaptiveHeight: true,
        wrapAround: true,


    });



}

// -------------------------- PDP subscription and one time purchase JS --------------------------
document.addEventListener('DOMContentLoaded', () => {
  // 1) Grab *all* purchase‐type radios
  const purchaseRadios = [
    ...document.querySelectorAll('input[id^="purchaseTypeSubscription"]'),
    ...document.querySelectorAll('input[id^="purchaseTypeOneTime"]')
  ];

  // 2) Grab your pack‐size radios
  const packRadios = document.querySelectorAll('input[data-variant-input]');

  function updateBundleBadges() {
    // which purchase‐type is checked?
    const subChecked = purchaseRadios
      .find(r => r.checked && r.id.startsWith('purchaseTypeSubscription'));

    packRadios.forEach(radio => {
      const onetime = radio.dataset.bundleOnetime || '';
      const sub     = radio.dataset.bundleSub     || '';

      // find the sibling badge span
      const container = radio.closest('.variant-input');
      if (!container) return;
      const badge = container.querySelector('.js-bundle-savings');
      if (!badge) return;

      // write the correct text
      badge.textContent = subChecked ? sub : onetime;
    });
  }

  // re-run on *any* change
  [...purchaseRadios, ...packRadios].forEach(el =>
    el.addEventListener('change', updateBundleBadges)
  );

  // initial paint
  updateBundleBadges();
});

/**
 * Product Sticky Add to Cart Footer
 * Syncs with product variant changes and connects to main product form
 */

(function() {
  'use strict';

  // Patch theme's Product.updatePrice immediately to prevent null reference errors
  // This must run before any Product instances are created
  function patchThemeUpdatePrice() {
    if (typeof theme !== 'undefined' && theme.Product && typeof theme.Product === 'function') {
      var ProductPrototype = theme.Product.prototype;
      if (ProductPrototype && ProductPrototype.updatePrice && !ProductPrototype.updatePrice._patched) {
        var originalUpdatePrice = ProductPrototype.updatePrice;
        ProductPrototype.updatePrice = function(evt) {
          var variant = evt.detail.variant;

          if (variant) {
            // If no price element, form initiated later than rest of product page. Update cached elements
            if (!this.cache || !this.cache.price) {
              if (this.cacheElements) {
                this.cacheElements();
              }
            }

            // Add null checks before setting innerHTML to prevent errors
            if (!this.cache || !this.cache.price) {
              // Price element doesn't exist, skip update
              return;
            }

            // Regular price
            this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

            // Sale price, if necessary
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              if (this.cache.comparePrice) {
                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
              }
              if (this.cache.priceWrapper) {
                // Try to get classes object, fallback to string
                var hiddenClass = (this.classes && this.classes.hidden) || 'hide';
                this.cache.priceWrapper.classList.remove(hiddenClass);
              }
              if (this.cache.price) {
                this.cache.price.classList.add('on-sale');
              }
              if (this.cache.comparePriceA11y) {
                this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
              }
              if (this.cache.priceA11y) {
                this.cache.priceA11y.setAttribute('aria-hidden', 'false');
              }

              var savings = variant.compare_at_price - variant.price;
              var saveType = theme.settings.saveType || 'dollar';
              if (saveType == 'percent') {
                savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
              } else {
                savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
              }

              if (this.cache.savePrice) {
                var hiddenClass = (this.classes && this.classes.hidden) || 'hide';
                this.cache.savePrice.classList.remove(hiddenClass);
                this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
              }
            } else {
              if (this.cache.priceWrapper) {
                var hiddenClass = (this.classes && this.classes.hidden) || 'hide';
                this.cache.priceWrapper.classList.add(hiddenClass);
              }
              if (this.cache.savePrice) {
                var hiddenClass = (this.classes && this.classes.hidden) || 'hide';
                this.cache.savePrice.classList.add(hiddenClass);
              }
              if (this.cache.price) {
                this.cache.price.classList.remove('on-sale');
              }
              if (this.cache.comparePriceA11y) {
                this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
              }
              if (this.cache.priceA11y) {
                this.cache.priceA11y.setAttribute('aria-hidden', 'true');
              }
            }
          }
        };
        ProductPrototype.updatePrice._patched = true;
      }
    } else {
      // If theme is not loaded yet, try again when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', patchThemeUpdatePrice);
      } else {
        // Try again after a short delay
        setTimeout(patchThemeUpdatePrice, 100);
      }
    }
  }

  // Apply patch immediately if possible
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    patchThemeUpdatePrice();
  } else {
    document.addEventListener('DOMContentLoaded', patchThemeUpdatePrice);
  }

  function ProductStickyCart(sectionId, productId) {
    this.sectionId = sectionId;
    this.productId = productId;
    this.container = document.getElementById('ProductStickyAddToCart-' + productId);
    this.currentVariantComparePrice = null; // Store current variant's compare price
    this.lastVariantId = null; // Track last variant ID to detect changes

    if (!this.container) {
      return;
    }

    this.selectors = {
      productImage: '[data-sticky-product-image]',
      productTitle: '[data-sticky-product-title]',
      variantTitle: '[data-sticky-variant-title]',
      price: '[data-sticky-price]',
      comparePrice: '[data-sticky-compare-price]',
      priceWrapper: '[data-sticky-price-wrapper]',
      addToCartBtn: '[data-sticky-add-to-cart]',
      addToCartText: '[data-sticky-add-to-cart-text]'
    };

    this.cacheElements();
    this.init();
  }

  ProductStickyCart.prototype = {
    cacheElements: function() {
      this.cache = {
        productImage: this.container.querySelector(this.selectors.productImage),
        productTitle: this.container.querySelector(this.selectors.productTitle),
        variantTitle: this.container.querySelector(this.selectors.variantTitle),
        price: this.container.querySelector(this.selectors.price),
        comparePrice: this.container.querySelector(this.selectors.comparePrice),
        priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
        addToCartBtn: this.container.querySelector(this.selectors.addToCartBtn),
        addToCartText: this.container.querySelector(this.selectors.addToCartText)
      };
    },


    init: function() {
      // Show sticky footer
      this.container.style.display = 'block';

      // Listen for variant change events
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (productSection) {
        productSection.addEventListener('variantChange', this.onVariantChange.bind(this));
        productSection.addEventListener('variantPriceChange', this.onPriceChange.bind(this));
        productSection.addEventListener('variantImageChange', this.onImageChange.bind(this));
      }

      // Listen for subscription/one-time purchase option changes
      this.setupSubscriptionListeners();

      // Connect sticky button to main form
      this.cache.addToCartBtn.addEventListener('click', this.onAddToCartClick.bind(this));

      // Initialize stored compare price from data attribute
      if (this.container) {
        var initialComparePrice = this.container.getAttribute('data-compare-at-price') ||
                                 this.container.dataset.compareAtPrice || '';
        if (initialComparePrice) {
          this.currentVariantComparePrice = initialComparePrice;
        }
      }

      // Initial update in case variant changes before listeners are attached
      // Use longer delay to ensure subscription pricing system has updated
      setTimeout(function() {
        this.updateFromVariantData();
        this.updatePriceFromDisplay();
      }.bind(this), 500);

      // Also update again after a bit more delay to catch any late updates
      setTimeout(function() {
        this.updatePriceFromDisplay();
      }.bind(this), 800);
    },

    setupSubscriptionListeners: function() {
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      // Listen for purchase type changes (subscription vs one-time)
      var purchaseTypeRadios = productSection.querySelectorAll('input[name^="purchaseType"], input[name="purchase_type"]');
      purchaseTypeRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          // Delay to let subscription system update prices
          setTimeout(function() {
            this.updatePriceFromDisplay();
          }.bind(this), 200);
        }.bind(this));
      }.bind(this));

      // Listen for selling plan/frequency changes
      var sellingPlanSelect = productSection.querySelector('select[name="selling_plan"], select[data-retextion-selling-plan-select]');
      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', this.updatePriceFromDisplay.bind(this));
      }

      // Listen for variant selector changes (for pack selection)
      var variantSelectors = productSection.querySelectorAll('[data-variant-input], input[name="id"], select[data-product-select]');
      variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', function() {
          // Delay to let subscription system update
          setTimeout(function() {
            this.updatePriceFromDisplay();
          }.bind(this), 200);
        }.bind(this));
      }.bind(this));

      // Watch for subscription price updates (Stay AI updates these elements)
      this.watchSubscriptionPriceUpdates();
    },

    watchSubscriptionPriceUpdates: function() {
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      // Watch for changes to subscription price elements (Stay AI)
      var subscriptionPriceEl = productSection.querySelector('[data-rtx-subscription-price]');
      var oneTimePriceEl = productSection.querySelector('[data-rtx-onetime-price]');

      if (subscriptionPriceEl) {
        var observer = new MutationObserver(this.updatePriceFromDisplay.bind(this));
        observer.observe(subscriptionPriceEl, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (oneTimePriceEl) {
        var observer2 = new MutationObserver(this.updatePriceFromDisplay.bind(this));
        observer2.observe(oneTimePriceEl, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      // Also watch the add-to-cart button price span
      var addToCartPriceEl = productSection.querySelector('[data-add-to-cart-text] .price');
      if (addToCartPriceEl) {
        var observer3 = new MutationObserver(this.updatePriceFromDisplay.bind(this));
        observer3.observe(addToCartPriceEl, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    },

    updatePriceFromDisplay: function() {
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      // Use the same price element that the main add-to-cart button uses
      // This is already updated correctly by the subscription system with the right compare and current prices
      var addToCartText = productSection.querySelector('[data-add-to-cart-text]');
      if (!addToCartText) return;

      var priceSpan = addToCartText.querySelector('.price');
      if (!priceSpan) return;

      // Get the HTML content which includes both compare price (with <s> tag) and current price
      var priceHTML = priceSpan.innerHTML.trim();
      var priceText = priceSpan.textContent.trim();

      // Extract prices from the text (compare price will be first, current price will be last)
      var prices = priceText.match(/[\$]?([\d,]+\.?\d*)/g);
      if (!prices || prices.length === 0) return;

      var displayedPrice = prices[prices.length - 1]; // Last price is always current
      var displayedComparePrice = prices.length >= 2 ? prices[0] : null; // First price is compare if exists

      // Update the sticky footer with prices
      if (displayedPrice && this.cache.price) {
        this.cache.price.textContent = displayedPrice;

        if (this.cache.comparePrice) {
          if (displayedComparePrice) {
            // Check if compare price is greater than current price
            var normalizePrice = function(priceStr) {
              if (!priceStr) return '';
              return priceStr.toString().replace(/[^0-9.]/g, '');
            };

            var compareNum = parseFloat(normalizePrice(displayedComparePrice));
            var currentNum = parseFloat(normalizePrice(displayedPrice));

            if (!isNaN(compareNum) && !isNaN(currentNum) && compareNum > currentNum) {
              this.cache.comparePrice.textContent = displayedComparePrice;
              this.cache.comparePrice.classList.remove('hide');
            } else {
              this.cache.comparePrice.textContent = '';
              this.cache.comparePrice.classList.add('hide');
            }
          } else {
            this.cache.comparePrice.textContent = '';
            this.cache.comparePrice.classList.add('hide');
          }
        }
      }
    },

    onVariantChange: function(evt) {
      var variant = evt.detail.variant;
      if (variant) {
        this.updateVariant(variant);
      }
    },

    onPriceChange: function(evt) {
      // Update from display to catch subscription pricing
      // Delay to ensure subscription system has updated prices
      setTimeout(function() {
        this.updatePriceFromDisplay();
      }.bind(this), 200);
    },

    onImageChange: function(evt) {
      var image = evt.detail.image;
      if (image && this.cache.productImage) {
        this.cache.productImage.src = image;
      }
    },

    updateFromVariantData: function() {
      // Try to get current variant from the product form
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      var variantSelect = productSection.querySelector('[data-product-select]');
      if (variantSelect && variantSelect.options[variantSelect.selectedIndex]) {
        try {
          var variantJson = productSection.querySelector('[data-variant-json]');
          if (variantJson) {
            var variants = JSON.parse(variantJson.textContent);
            var selectedVariantId = parseInt(variantSelect.value);
            var variant = variants.find(function(v) {
              return v.id === selectedVariantId;
            });
            if (variant) {
              this.updateVariant(variant);
            }
          }
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }

      // Also try to get compare price from DOM if variant JSON doesn't have it
      // This ensures we have the compare price even if variant JSON is incomplete
      if (!this.currentVariantComparePrice) {
        this.updateComparePriceFromDOM();
      }
    },

    getComparePriceFromDOM: function(productSection, subscriptionSelected) {
      // Try to get compare price from the appropriate purchase option element
      if (!productSection) return null;

      var priceEl = null;
      if (subscriptionSelected) {
        // Try subscription price element first
        priceEl = productSection.querySelector('[data-rtx-subscription-price]');
      } else {
        // Try one-time price element
        priceEl = productSection.querySelector('[data-rtx-onetime-price]');
      }

      if (priceEl) {
        // First, try data attribute
        var comparePriceAttr = priceEl.getAttribute('data-compare-at-price');
        if (comparePriceAttr && comparePriceAttr.trim() !== '') {
          return comparePriceAttr.trim();
        }

        // Try to extract from displayed text (e.g., "$90 $76.50")
        var priceText = priceEl.textContent.trim() || priceEl.innerText.trim() || '';
        var prices = priceText.match(/[\$]?([\d,]+\.?\d*)/g);
        if (prices && prices.length >= 2) {
          // First price is typically the compare price if there are two
          return prices[0];
        }
      }

      // Fallback: try the other purchase option element
      var fallbackEl = subscriptionSelected
        ? productSection.querySelector('[data-rtx-onetime-price]')
        : productSection.querySelector('[data-rtx-subscription-price]');

      if (fallbackEl) {
        var comparePriceAttr = fallbackEl.getAttribute('data-compare-at-price');
        if (comparePriceAttr && comparePriceAttr.trim() !== '') {
          return comparePriceAttr.trim();
        }
      }

      return null;
    },

    updateComparePriceFromDOM: function() {
      // Try to get compare price from various DOM sources
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      // First try the sticky footer's data attribute (set by Liquid on page load)
      if (this.container) {
        var comparePriceAttr = this.container.getAttribute('data-compare-at-price');
        if (comparePriceAttr) {
          this.currentVariantComparePrice = comparePriceAttr;
          return;
        }
      }

      // Try the one-time price element's data attribute
      var oneTimePriceEl = productSection.querySelector('[data-rtx-onetime-price]');
      if (oneTimePriceEl) {
        var comparePriceAttr = oneTimePriceEl.getAttribute('data-compare-at-price');
        if (comparePriceAttr) {
          this.currentVariantComparePrice = comparePriceAttr;
          return;
        }

        // Try to extract from displayed text (e.g., "$90 $76.50")
        var oneTimeText = oneTimePriceEl.textContent.trim() || oneTimePriceEl.innerText.trim() || '';
        var prices = oneTimeText.match(/[\$]?([\d,]+\.?\d*)/g);
        if (prices && prices.length >= 2) {
          // First price is typically the compare price if there are two
          this.currentVariantComparePrice = prices[0];
          return;
        }
      }

      // Also try subscription price element
      var subPriceEl = productSection.querySelector('[data-rtx-subscription-price]');
      if (subPriceEl) {
        var comparePriceAttr = subPriceEl.getAttribute('data-compare-at-price');
        if (comparePriceAttr) {
          this.currentVariantComparePrice = comparePriceAttr;
          return;
        }

        // Try to extract from displayed text
        var subText = subPriceEl.textContent.trim() || subPriceEl.innerText.trim() || '';
        var prices = subText.match(/[\$]?([\d,]+\.?\d*)/g);
        if (prices && prices.length >= 2) {
          this.currentVariantComparePrice = prices[0];
          return;
        }
      }
    },

    updateVariant: function(variant) {
      // Update availability and button state
      if (this.cache.addToCartBtn) {
        if (variant.available) {
          this.cache.addToCartBtn.disabled = false;
          if (this.cache.addToCartText) {
            this.cache.addToCartText.textContent = 'ADD TO CART';
          }
        } else {
          this.cache.addToCartBtn.disabled = true;
          if (this.cache.addToCartText) {
            this.cache.addToCartText.textContent = theme.strings ? theme.strings.soldOut.toUpperCase() : 'SOLD OUT';
          }
        }
      }

      // Update variant title if it exists
      if (this.cache.variantTitle && variant.title && variant.title !== 'Default Title') {
        this.cache.variantTitle.textContent = variant.title;
        this.cache.variantTitle.style.display = '';
      } else if (this.cache.variantTitle) {
        this.cache.variantTitle.style.display = 'none';
      }

      // Update price display - delay to allow subscription system to update the add-to-cart button's price span
      setTimeout(function() {
        this.updatePriceFromDisplay();
      }.bind(this), 200);

      // Update again after subscription system fully processes
      setTimeout(function() {
        this.updatePriceFromDisplay();
      }.bind(this), 800);

      // Update image if variant has a featured image
      if (variant.featured_image && this.cache.productImage) {
        var imageUrl = variant.featured_image.src || variant.featured_image.url;
        if (imageUrl) {
          // Get smaller size for thumbnail
          imageUrl = imageUrl.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_100x100.$1$2');
          this.cache.productImage.src = imageUrl;
        }
      }
    },

    updatePrice: function(price, comparePrice) {
      if (!this.cache.price) return;

      // Format money without trailing zeros (matching Liquid's money_without_trailing_zeros)
      var formattedPrice = this.formatMoneyWithoutTrailingZeros(price);
      this.setPriceContent(this.cache.price, formattedPrice);

      // Update compare price
      if (this.cache.comparePrice) {
        if (comparePrice && comparePrice > price) {
          var formattedComparePrice = this.formatMoneyWithoutTrailingZeros(comparePrice);
          this.setPriceContent(this.cache.comparePrice, formattedComparePrice);
          this.cache.comparePrice.classList.remove('hide');
        } else {
          this.cache.comparePrice.textContent = '';
          this.cache.comparePrice.innerHTML = '';
          this.cache.comparePrice.classList.add('hide');
        }
      }
    },

    setPriceContent: function(element, content) {
      // Handle both HTML (with sup tags) and plain text
      if (content && content.includes('<')) {
        element.innerHTML = content;
      } else {
        element.textContent = content;
      }
    },

    formatMoneyWithoutTrailingZeros: function(cents) {
      if (!theme || !theme.Currency) {
        // Fallback formatting
        var amount = (cents / 100).toFixed(2);
        return '$' + amount.replace(/\.?0+$/, '');
      }

      // Use theme's formatMoney and remove trailing zeros
      var formatted = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);

      // Remove trailing zeros after decimal point
      // Handle HTML formatting (with <sup> tags)
      if (formatted.includes('<sup>')) {
        // If it has superscript, extract text, remove trailing zeros, then reconstruct
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = formatted;
        var text = tempDiv.textContent || tempDiv.innerText || '';
        // Replace trailing .00 or .0
        text = text.replace(/\.?0+$/, '');
        // Try to preserve superscript structure by replacing the numeric part
        var numericMatch = formatted.match(/(\d+)(\.\d+)?(<sup>.*?<\/sup>)?/);
        if (numericMatch) {
          return formatted.replace(/\d+\.?\d*/, text);
        }
        return text;
      } else {
        // Regular text, just remove trailing zeros
        return formatted.replace(/\.?0+$/, '');
      }
    },

    onAddToCartClick: function(evt) {
      evt.preventDefault();

      // Find and click the main product form's add to cart button
      var productSection = document.getElementById('ProductSection-' + this.sectionId + '-' + this.productId);
      if (!productSection) return;

      var mainAddToCartBtn = productSection.querySelector('[data-add-to-cart]');
      if (mainAddToCartBtn) {
        // Add loading state
        this.cache.addToCartBtn.classList.add('btn--loading');
        mainAddToCartBtn.click();

        // Remove loading state after a short delay (the main form handler will manage the actual state)
        var self = this;
        setTimeout(function() {
          self.cache.addToCartBtn.classList.remove('btn--loading');
        }, 1000);
      }
    }
  };

  // Initialize on DOM ready
  function initStickyCart() {
    var productSections = document.querySelectorAll('[data-section-type="product"]');
    productSections.forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      var productId = section.dataset.productId;

      if (sectionId && productId) {
        new ProductStickyCart(sectionId, productId);
      }
    });
  }

  // Wait for DOM and theme to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    // DOM already ready, but wait a bit for theme.js to load
    if (window.theme && window.theme.Currency) {
      initStickyCart();
    } else {
      window.addEventListener('load', initStickyCart);
    }
  }
})();

